import React from 'react'
import _ from 'lodash'
import { ICONS } from 'icons'
import { Avatar, AvatarProps } from 'components/Shared/Avatar'
import { SignerDetail } from './SignerDetail'
import s from './styles.module.scss'

interface OrderSignerDetailsViewProps {
  firstName?: string
  lastName?: string
  email?: string
  mobilePhone?: string
  workPhone?: string
  homePhone?: string
  avatarProps?: AvatarProps
  isCosigner?: boolean
}

export const OrderSignerDetailsView: React.FC<OrderSignerDetailsViewProps> = ({
  firstName,
  lastName,
  email,
  mobilePhone,
  workPhone,
  homePhone,
  avatarProps,
  isCosigner
}) => {
  const userInitials = (_.first(firstName) || '') + _.first(lastName)
  const avatarElement = email ? (
    <div className={s.signerView__avatar}>
      <Avatar initials={userInitials} {...avatarProps} />
    </div>
  ) : null

  return (
    <div className={s.signerView}>
      {avatarElement}
      <div className={s.signerView__details}>
        <div className={s.signerView__nameRow}>
          <div className={s.signerView__nameContainer}>
            <SignerDetail
              dataTestId={isCosigner ? 'cosigner-name' : 'primary-signer-name'}
              value={`${firstName} ${lastName}`}
            />
          </div>
        </div>
        <SignerDetail
          dataTestId="signer-email"
          icon={ICONS.EMAIL}
          value={email}
          className={s.signerView__emailDetail}
        />
        <SignerDetail dataTestId="signer-mobile-phone" icon={ICONS.MOBILE_PHONE} value={mobilePhone} />
        <SignerDetail dataTestId="signer-home-phone" icon={ICONS.HOME_PHONE} value={homePhone} />
        <SignerDetail dataTestId="signer-work-phone" icon={ICONS.WORK_PHONE} value={workPhone} />
      </div>
    </div>
  )
}

export default OrderSignerDetailsView
